import * as form from '../../form';
import {i18n} from '../i18n';

declare const faculties: Faculty[];

export class FacultyController extends form.Controller {
  readonly pattern = undefined;
  readonly listeners = [
  ];
  private static selector?: FacultySelector;
  async onready() {
  }
  static onready() {
    const table: HTMLElement = document.querySelector('#faculty-table')!;
    if (table) {
      this.selector = new FacultySelector(JSON.parse(table.dataset['json']!));
    }
  }
  static checkValidity() {
    if (!this.selector)
      return true;
    return this.selector.checkValidity();
  }
}

class FacultySelector {
  readonly faculties: readonly Faculty[]
  readonly groups: readonly SelectGroup[];
  readonly addButton = document.querySelector('.faculty-add') as HTMLElement;
  constructor(faculties: readonly Faculty[]) {
    this.faculties = faculties.map(faculty => new Faculty(faculty));
    const containers = document.querySelectorAll('.faculty-select');
    this.groups = Array.from(containers).map(container => {
      return new SelectGroup(container as HTMLElement, this);
    });
    for (const group of this.groups.slice().reverse()) {
      if (group.facultyId.value != '' && !group.required) {
        group.showDeleteButton();
        break;
      }
    }
    this.addButton.addEventListener('click', () => {
      this.groups.find(g => !g.visible())!.show();
      this.updateButtonsVisiblity();
    });
    this.updateButtonsVisiblity()
  }
  private matches(facultyId: number, index: number) {
    const faculty = this.faculties.find(faculty => faculty.id == facultyId)!;
    const categoryCode = faculty.categoryCode(index);
    return this.faculties.filter(faculty => {
      return faculty.categoryCode(index) == categoryCode;
    });
  }
  options(facultyId: number, index: number) {
    const faculties: [string, Faculty[]][] = [];
    for (const faculty of this.matches(facultyId, index)) {
      const category = faculty.categories[index]!;
      if (faculties.findIndex(taple => taple[0] == category.code) < 0)
        faculties.push([category.code, []]);
      const taple = faculties.find(taple => taple[0] == category.code)!;
      taple[1].push(faculty);
    }
    return faculties.map(taple => {
      const category = taple[1][0]!.categories[index]!;
      const option = document.createElement('option');
      option.text = this.categoryName(category);
      option.value = taple[1].map(faculty => faculty.id).join('-');
      return option;
    });
  }
  topOptions() {
    const faculties2: [string, Faculty[]][] = [];
    for (const faculty of this.faculties) {
      const category = faculty.categories[0]!;
      const index = faculties2.findIndex(taple => taple[0] == category.code);
      if (index < 0)
        faculties2.push([category.code, []]);
      const taple = faculties2.find(taple => taple[0] == category.code)!;
      taple[1].push(faculty);
    }
    const options = [document.createElement('option')];
    for (const taple of faculties2) {
      const category = taple[1][0]!.categories[0]!;
      const option = document.createElement('option');
      option.text = this.categoryName(category);
      option.value = taple[1].map(faculty => faculty.id).join('-');
      options.push(option);
    }
    return options;
  }
  private showAddButton() {
    this.addButton.classList.remove('hidden');
  }
  private hideAddButton() {
    this.addButton.classList.add('hidden');
  }
  updateButtonsVisiblity() {
    for (const group of this.groups)
      group.hideDeleteButton();
    this.groups.slice().reverse().find(
      g => g.visible() && !g.required)?.showDeleteButton();
    const last = this.groups[this.groups.length - 1]!;
    if (last.visible())
      this.hideAddButton();
    else
      this.showAddButton();
  }
  checkValidity() {
    const facultyIds: {
      [id: string]: SelectGroup;
    } = {};
    let valid = true;
    for (const group of this.groups) {
      if (!group.visible())
        continue;
      const id = group.facultyId.value;
      if (facultyIds[id]) {
        group.last.classList.add('invalid-input');
        group.last.setCustomValidity(i18n('duplicate'));
        facultyIds[id]!.last.classList.add('invalid-input');
        facultyIds[id]!.last.setCustomValidity(i18n('duplicate'));
        valid = false;
      }
      facultyIds[id] = group;
    }
    return valid;
  }
  private categoryName(category: Category) {
    switch (document.documentElement.lang) {
      case 'ja':
        return category.name_ja;
      case 'en':
        return category.name_en;
    }
    throw new Error;
  }
}

class SelectGroup {
  readonly selects: HTMLSelectElement[];
  readonly last;
  readonly facultyId: HTMLInputElement;
  readonly _destroy: HTMLInputElement;
  readonly required;
  readonly delete: HTMLButtonElement;
  constructor(readonly container: HTMLElement,
              readonly selector: FacultySelector) {

    this.selects = Array.from(this.container.querySelectorAll('select'));
    this.last = this.selects[this.selects.length - 1]!;
    this.facultyId = this.container.querySelector('input[name$="[faculty_id]"]')!;
    this._destroy = this.container.querySelector('input[name$="[_destroy]"]')!
    this.required = this.container.hasAttribute('data-required');
    this.delete = this.container.querySelector('.faculty-delete')!;


    this.toggleRequiredAttribute(true);
    for (const select of this.selects) {
      select.disabled = true;
      select.addEventListener('change', event => {
        this.onchange(event.target as HTMLSelectElement);
      });
    }
    const select0 = this.selects[0]!;
    for (const option of selector.topOptions())
      select0.append(option);
    select0.disabled = false;
    this._destroy.value = '1';
    if (this.facultyId.value) {
      const facultyId = this.facultyId.value;
      for (const select of this.selects) {
        for (const option of Array.from(select.options)) {
          if (option.value.split('-').includes(facultyId)) {
            select.value = option.value;
            this.onchange(select);
          }
        }
      }
    }
    if (this.facultyId.value == '' && !this.required)
      this.hide();
    this.delete.addEventListener('click', () => {
      select0.selectedIndex = 0;
      for (const select of this.selects.slice(1))
        for (const option of Array.from(select.options))
          option.remove();
      this.hide();
      this.selector.updateButtonsVisiblity();
    });
  }
  onchange(target: HTMLSelectElement) {
    this.facultyId.value = '';
    this._destroy.value = '1';
    const index = this.selects.findIndex(select => select == target) + 1;
    for (const select of this.selects.slice(index)) {
      for (const option of Array.from(select.options))
        option.remove();
      select.disabled = true;
    }
    if (!target.value)
      return;
    const select = this.selects[index];
    if (select) {
      select.append(document.createElement('option'));
      const options = this.selector.options(parseInt(target.value), index);
      for (const option of options)
        select.append(option);
      select.disabled = false;
    } else {
      this.facultyId.value = target.value;
      this._destroy.value = '';
    }
  }
  visible() {
    return !this.container.classList.contains('hidden');
  }
  show() {
    this.container.classList.remove('hidden');
    this.toggleRequiredAttribute(true);
  }
  hide() {
    this.container.classList.add('hidden');
    this.toggleRequiredAttribute(false);
  }
  showDeleteButton() {
    this.delete.classList.remove('hidden');
  }
  hideDeleteButton() {
    this.delete.classList.add('hidden');
  }
  private toggleRequiredAttribute(force: boolean) {
    for (const select of this.selects)
      select.required = force;
    if (!force)
      this._destroy.value = '1';
  }
}

class Faculty {
  readonly id: number;
  readonly categories: Category[];
  constructor({id, categories}: Faculty) {
    this.id = id;
    this.categories = categories;
  }
  categoryCode(length: number) {
    return this.categories.slice(0, length).map(c => c.code).join('-');
  }
}

interface Category {
  readonly code: string;
  readonly name_ja: string;
  readonly name_en: string;
}
